import './index.sass';
import axios from "axios";

export default ($root) => {
    $root.find('.article-controls__moderate').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);

        axios.post($this.data('url'), {}, {
            headers: {
                'Accept': 'application/json',
                "X-CSRF-Token": $('meta[name=csrf-token]').attr('content')
            }
        }).then(({ data }) => {
            if (data.moderate) {
                $this.addClass('article-controls__moderate--moderated')
            } else {
                $this.removeClass('article-controls__moderate--moderated')
            }
        });
    });
}
